import { render, staticRenderFns } from "./InboundDash.vue?vue&type=template&id=192a34c0&"
import script from "./InboundDash.vue?vue&type=script&lang=js&"
export * from "./InboundDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports